import { useMemo } from 'react';

import TextDisplayBlock from '@apigrowfinance/pbolt-text-display-block';
import dayjs from 'dayjs';
import { useIntl } from 'react-intl';

import { ITimelineItem } from '@clients/timelineClient';
import accountTimelineCategoryDesc from '@messages/accountTimelineCategoryDesc';
import getEnumTranslation from '@utils/getEnumTranslation';
import { toTitleCase } from '@utils/string/caseUtils';

interface TimelineDetailsBodyCardProps {
    timelineItem: ITimelineItem;
    isLoading?: boolean;
}

const TimelineDetailsBodyCard = ({
    timelineItem,
    isLoading,
}: TimelineDetailsBodyCardProps) => {
    const { formatMessage } = useIntl();

    const textBlocks = useMemo(() => {
        return [
            {
                label: formatMessage({
                    id: 'TimelineDetails.description',
                    defaultMessage: 'Description',
                }),
                value: timelineItem?.category
                    ? (getEnumTranslation(timelineItem?.category + '_DESC', {
                          messages: accountTimelineCategoryDesc,
                          formatMessage,
                      }) as string)
                    : '',
                width: 12,
            },
            {
                label: ' ',
                value: ' ',
                width: 12,
            },
            {
                label: formatMessage({
                    id: 'TimelineDetails.type',
                    defaultMessage: 'Type',
                }),
                value: toTitleCase(timelineItem?.type),
            },
            {
                label: formatMessage({
                    id: 'TimelineDetails.category',
                    defaultMessage: 'Category',
                }),
                value: toTitleCase(timelineItem?.category),
            },
            {
                label: formatMessage({
                    id: 'TimelineDetails.stage',
                    defaultMessage: 'Stage',
                }),
                value: toTitleCase(timelineItem?.data?.item?.stage),
            },
            {
                label: formatMessage({
                    id: 'TimelineDetails.name',
                    defaultMessage: 'Name',
                }),
                value: toTitleCase(timelineItem?.data?.item?.name),
            },
            {
                label: formatMessage({
                    id: 'TimelineDetails.printedName',
                    defaultMessage: 'Printed Name',
                }),
                value: toTitleCase(timelineItem?.data?.item?.printed_name),
            },
            {
                label: formatMessage({
                    id: 'TimelineDetails.type',
                    defaultMessage: 'Type',
                }),
                value: toTitleCase(timelineItem?.data?.item?.type),
            },
            {
                label: formatMessage({
                    id: 'TimelineDetails.status',
                    defaultMessage: 'Status',
                }),
                value: toTitleCase(timelineItem?.data?.item?.status),
            },
            {
                label: formatMessage({
                    id: 'TimelineDetails.correlationId',
                    defaultMessage: 'Correlation Id',
                }),
                value: timelineItem?.correlation_id,
                width: 6,
            },
            {
                label: formatMessage({
                    id: 'TimelineDetails.timestamp',
                    defaultMessage: 'Timestamp',
                }),
                value: dayjs(timelineItem?.timestamp).format(
                    'D MMM YYYY h:mmA',
                ),
                width: 6,
            },
        ];
    }, [timelineItem, formatMessage]);

    return <TextDisplayBlock isLoading={isLoading} textBlocks={textBlocks} />;
};

export default TimelineDetailsBodyCard;
